import React, { useEffect, useState } from "react";
import Loader from "../../../components/loader";
import PieceConfirmList from "../../../components/piece/pieceConfirmList";
import SearchBar from "../../../components/searchBar";
import { useDashboardContext } from "../../../context/dashboardContext";
import { PieceAdminResponseDTO } from "../../../openapi-generated-client";
import { useSafeNavigate } from "../../../components/unloadBlocker";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/button";

export default function DashboardAdminAllPieces() {

    const navigate = useSafeNavigate(useNavigate());

    const {sessionId, appContext} = useDashboardContext();
    const {pieceController} = appContext;

    const [search, setSearch] = React.useState("");

    const [data, setData] = useState<PieceAdminResponseDTO[]>();

    async function fetchData() {
        setData((await pieceController.getAllPieces(sessionId)).data);
    }

    useEffect(() =>{
        fetchData();
    }, []);

    if(data == undefined) return <Loader/>;

    return <div className="page">
            <SearchBar search={search} onSearch={setSearch}/>
            <Button onClick={() => {
                navigate("create");
            }}>Create Piece</Button>
            <PieceConfirmList refetch={fetchData} searchQuery={search} pieceLinkPrefix="/dashboard/admin/pieces" pieces={data}/>
        </div>;
    
}